import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";

export default function userHasSearchAccess(user: ISelfieQuery["selfie"] | null) {
  if (!user) {
    return false;
  }

  if (user.__typename === "PendingUser" && user.verified) {
    return true;
  }

  if (user.__typename === "GovernmentUser") {
    return true;
  }

  return (
    user.__typename === "VendorUser" &&
    user.company &&
    user.company.plan &&
    user.company.plan.limits &&
    user.company.plan.limits.searchAccess
  );
}
